/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_CrumbInputs */

const en_auth_login_crumb = /** @type {(inputs: Auth_Login_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

const pl_auth_login_crumb = /** @type {(inputs: Auth_Login_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {Auth_Login_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_crumb = /** @type {((inputs?: Auth_Login_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_crumb(inputs)
	return en_auth_login_crumb(inputs)
});